import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  margin-top: -52px;
  display: flex;
  flex-wrap: wrap;
  #newBtn {
    width: 188px;
    height: 128px;
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;
    background: white;
    border: 1px dashed black;
    border-radius: 5px;
    margin-left: 58px;
    flex-flow: column;
    transition: all .25s;
    :hover {
      cursor: pointer;
      background: #222222;
      color: white;
    }
  }
  #plus {
    font-weight: bold;
    font-size: 28px;
    color: #848484;
  }
`

export const Card = styled.div`
  width: fit-content;
  box-shadow: 1px 2px 6px -1px #c5c5c5;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  font-family: Avenir;
  margin-right: 34px;
  margin-bottom: 32px;
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 128px;
`

export const TopLabel = styled.div`
  background: whitesmoke;
  padding: 12px 24px;
  display: flex;
`

export const LeftDiv = styled.div`
  width: 142px;
`

export const RightDiv = styled.div`
  width: 84px;
`

export const GenderLabel = styled.div`
  flex: 1;
  text-align: center;
`

export const MetricArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 12px 24px;
  column-gap: 16px;
`

export const FieldDiv = styled.div`
  display: flex;
  margin-bottom: 14px;
`

export const RenderArea = styled.div`
  width: 344px;
  margin-top: 42px;
  border-left: 1px solid #eeeeee;
  background: #fafafa;
  height: 438px;
`

export const PopoverImage = styled.img`
  width: 386px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FitProfiles/styledComponents.tsx